import React, { FC, memo } from "react";
import PaginationButton from "./PaginationButton";

interface PackagesPaginationProps {
  count: number;
  selectedIndex: number;
  onSelect: (index: number) => void;
}

const PackagesPagination: FC<PackagesPaginationProps> = ({
  count,
  selectedIndex,
  onSelect,
}) => {
  const items = () =>
    [...Array(count)].map((_, i) => {
      const buttonHandler = () => onSelect(i);

      return (
        <PaginationButton
          key={i}
          $selected={selectedIndex === i}
          onClick={buttonHandler}
        >
          {i + 1}
        </PaginationButton>
      );
    });

  return <div>{items()}</div>;
};

export default memo(PackagesPagination);
